import React from "react";
import Header from "../components/Header/Header";
import Homepage from "../components/Homepage/Homepage";

const Home = () => {
  return (
    <div>
      <Header />
      <Homepage />
    </div>
  );
};

export default Home;
